import { render, staticRenderFns } from "./HeaderedBar.vue?vue&type=template&id=6b052b92&slot=header&"
import script from "./HeaderedBar.vue?vue&type=script&lang=js&"
export * from "./HeaderedBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports